import { render, staticRenderFns } from "./EditEmployeeModal.vue?vue&type=template&id=60716134"
import script from "./EditEmployeeModal.vue?vue&type=script&lang=ts"
export * from "./EditEmployeeModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports